module.exports = __webpack_public_path__ + "img/rightBottom1.ecf5a62.svg";